import { PropsWithChildren, createContext, useContext, useMemo } from 'react';
import { EActionDetailNotice } from 'src/presentations/components/organisms/actionDetails/Notice';

interface IFormFieldContext {
  showUCTNotice: EActionDetailNotice;
}

const FormFieldContext = createContext<IFormFieldContext | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export const useFormFieldContext = () => {
  const context = useContext(FormFieldContext);
  if (!context) {
    throw new Error('No Context found. useFormFieldContext must be used inside custom FormFieldContext.');
  }
  return context;
};

// Custom FormContainer to provide a custom context
export const FormFieldProvider = (props: PropsWithChildren<IFormFieldContext>) => {
  const { children, showUCTNotice } = props;

  const contextValue = useMemo(() => ({ showUCTNotice }), [showUCTNotice]);

  return <FormFieldContext.Provider value={contextValue}>{children}</FormFieldContext.Provider>;
};
